// extracted by mini-css-extract-plugin
module.exports = {"number":"style-module__number___qvToz","box":"style-module__box___3LbNA","code":"style-module__code___20sOe","hint":"style-module__hint___3DWjG"};